import { Icon } from '@zillow/constellation-10';
import { IconUserAddFilled } from '@zillow/constellation-icons';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';

import EmptyState from '../../../EmptyState';
import SimpleCard from '../../../SimpleCard';
import ApplicationShareLinks from '../ApplicationShareLinks';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
};

const EmptyApplicationsCardSimple = ({ displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  return (
    <SimpleCard data-testid="EmptyApplicationsCardSimple">
      <EmptyState
        useCard={false}
        align="left"
        headingLevel={4}
        icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconUserAddFilled />} />}
        heading="You don’t have any applications yet"
        body="You can invite renters to apply or wait for renters to apply via your listing on Zillow Rental Network."
        actions={<ApplicationShareLinks displayType={displayType} />}
      />
    </SimpleCard>
  );
};

export default EmptyApplicationsCardSimple;
